import React, { createContext, useContext } from 'react';
import { hqvInitialStateType, HQV_ACTIONS } from '../../reducers/HQV';

interface HqvDispatch {
  type: HQV_ACTIONS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

export const HQVContext = createContext<{
  hqvState: hqvInitialStateType;
  hqvDispatch: React.Dispatch<HqvDispatch>;
}>({
  hqvState: {
    amenetiesAvailable: false,
    informationAvailable: false,
    photosAvailable: false,
    propertyDetailsAbailable: false,
    propertyIDvalue: '',
    modalOpenState: false,
    openGalleryOnLoad: false,
    propertySessionData: {},
    propertyDistanceValue: '',
    cachedPropertyMedia: undefined,
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  hqvDispatch: () => {},
});

export const useHQVContext = () => {
  return useContext(HQVContext);
};
